import {Injectable} from '@angular/core';
import {PagingApiService} from '@abstract/paging-api.service';
import {BehaviorSubject} from 'rxjs/internal/BehaviorSubject';
import {BrowserStorageDataEnum} from '@services/browser-storage.service';
import {Conclusion} from '@namespaces/conclusion.namespace';
import {DirectionEnum} from '../../../../../enums/direction.enum';

enum SortBy {
    number = 'number',
    date = 'date',
    working_object = 'working_object',
    control_order = 'control_order',
    method = 'method',
    scan = 'scan',
    status = 'status',
}

@Injectable()
export class ConclusionPagesService extends PagingApiService<Conclusion.ListViewItem, SortBy> {
    protected baseUrl = 'conclusion/pages';

    itemsPerPageCounts = [25, 50, 100];

    defaultItemsPerPage = 25;

    itemsPerPageStorageKey = BrowserStorageDataEnum.conclusionItemsPerPageCount;

    public sortByEnum = SortBy;

    sortBy$ = new BehaviorSubject<SortBy>(SortBy.date);
    sortDirection$ = new BehaviorSubject<DirectionEnum>(DirectionEnum.down);

    resetParams() {
        super.resetParams();
        this.sortBy$.next(SortBy.date);
    }
}
